import { z } from "zod";
import { responseSchema } from "../http.js";
import { OPERATING_COUNTRIES } from "./country.js";
/**
 * ═══════════════════════════════════════════════════════════
 * Desde qué país se conecta quien mira la tienda (Anahí, 14-sep-2026)
 *
 * «Que detecte en qué país se está conectando: si es México, pesos; si
 * es Estados Unidos, dólares. El idioma sí se puede cambiar; la moneda
 * no.» Desde este día la MONEDA la decide la conexión, y el idioma es
 * una preferencia aparte (ver `useShopCurrency` y `useLanguage` en el
 * frontend).
 *
 * El servidor lee el país de las cabeceras que ponen los proxies de
 * Google delante de Cloud Run. Si ninguna viene, responde `null` y el
 * navegador decide con su zona horaria (`geo.client.ts`). Nunca se
 * adivina un tercer país: solo MX o US, que es donde se cobra.
 * ═══════════════════════════════════════════════════════════
 */
export const geoDataSchema = z.object({
    /** `null` = el servidor no pudo saberlo (o no es MX/US). */
    country: z.enum(OPERATING_COUNTRIES).nullable(),
    /** El código crudo que llegó (cualquier país), para diagnóstico. */
    detected: z.string().nullable(),
});
export const geoResponseSchema = responseSchema(geoDataSchema);
export const GEO_ROUTES = {
    detect: "/api/geo",
};
//# sourceMappingURL=geo.js.map